import { Box, Chip } from '@mui/material';
import { timeSlotsStepLoadingChip, timeSlotsStepLoadingChipContent, timeSlotsStepLoadingWrapperStyles } from './TimeSlotsStepLoading.styles';
export const TimeSlotsStepLoading = () => {
  return <Box sx={timeSlotsStepLoadingWrapperStyles} data-test-id="time-slots-step-loading-wrapper" data-sentry-element="Box" data-sentry-component="TimeSlotsStepLoading" data-sentry-source-file="TimeSlotsStepLoading.tsx">
			{[0, 1, 2, 3, 4, 5, 6, 7, 8].map(i => <Chip key={i} variant="default" sx={timeSlotsStepLoadingChip} label={<Box sx={timeSlotsStepLoadingChipContent}>.........</Box>} />)}
		</Box>;
};